/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { themeToken } from '../../utils/cpds-utils';

import { CpdsInlinePullQuoteBackgroundTypes } from '../const';
import { cpdsMediaQueryVals } from 'src/components/common/cpds/token/shared/common';

const colorMapper = (props, token) => {
  let background, quoteMarkColor, titleColor, authorColor, jobTitleColor;

  switch (props?.background) {
    case CpdsInlinePullQuoteBackgroundTypes.PRIMARY:
      background = token.inline_pull_quote_background_primary_color;
      quoteMarkColor = token.inline_pull_quote_title_text_primary_color;
      titleColor = token.inline_pull_quote_title_text_primary_color;
      authorColor = token.inline_pull_quote_author_text_primary_color;
      jobTitleColor = token.inline_pull_quote_author_text_primary_color;
      break;
    case CpdsInlinePullQuoteBackgroundTypes.SECONDARY:
      background = token.inline_pull_quote_background_secondary_color;
      quoteMarkColor = token.inline_pull_quote_title_text_primary_color;
      titleColor = token.inline_pull_quote_title_text_primary_color;
      authorColor = token.inline_pull_quote_author_text_primary_color;
      jobTitleColor = token.inline_pull_quote_author_text_primary_color;
      break;
    case CpdsInlinePullQuoteBackgroundTypes.TERTIARY:
      background = token.inline_pull_quote_background_tertiary_color;
      quoteMarkColor = token.inline_pull_quote_title_text_tertiary_color;
      titleColor = token.inline_pull_quote_title_text_tertiary_color;
      authorColor = token.inline_pull_quote_title_text_tertiary_color;
      jobTitleColor = token.inline_pull_quote_title_text_tertiary_color;
      break;
    default:
      background = token.inline_pull_quote_background_primary_color;
      quoteMarkColor = token.inline_pull_quote_title_text_primary_color;
      titleColor = token.inline_pull_quote_title_text_primary_color;
      authorColor = token.inline_pull_quote_author_text_primary_color;
      jobTitleColor = token.inline_pull_quote_author_text_primary_color;
  }

  return {
    background,
    quoteMarkColor,
    titleColor,
    authorColor,
    jobTitleColor,
  };
};

const CpdsInlinePullQuoteQuotationMark = styled.svg`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { quoteMarkColor } = colorMapper(props, token);

    return css`
      position: absolute;
      top: 25px;
      right: calc(100% - 24px);
      width: 14px;
      height: 40px;

      & path {
        fill: ${quoteMarkColor};
      }

      @media screen and (max-width: ${cpdsMediaQueryVals.cpds_large_lower_limit}) {
        right: calc(100% - 40px);
      }

      @media screen and (max-width: ${cpdsMediaQueryVals.cpds_small_upper_limit}) {
        top: 18px;
        width: 10px;
        height: 32px;
        right: calc(100% - 16px);
      }
    `;
  }}
`;

const CpdsInlinePullQuoteTitleStyleTag = styled.h2`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { titleColor } = colorMapper(props, token);
    return css`
      color: ${titleColor};
      padding: ${token.spacing.space_12} 0 ${token.spacing.space_40} 0;

      @media screen and (max-width: ${cpdsMediaQueryVals.cpds_large_lower_limit} ) {
        padding: ${token.spacing.space_12} 0 ${token.spacing.space_16} 0;
      }
    `;
  }}
`;

const CpdsInlinePullQuoteAuthorStyleTag = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { authorColor } = colorMapper(props, token);

    return css`
      color: ${authorColor};
      margin-bottom: ${token.spacing.space_2};
      font-weight: ${token.inline_pull_quote_author_font_weight || 500} !important;
      @media screen and (max-width: ${cpdsMediaQueryVals.cpds_small_upper_limit}) {
        font-size: 16px !important;
        line-height: 24px !important;
      }
    `;
  }}
`;

const CpdsInlinePullQuoteJobTitleStyleTag = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { jobTitleColor } = colorMapper(props, token);

    return css`
      color: ${jobTitleColor};
      @media screen and (max-width: ${cpdsMediaQueryVals.cpds_small_upper_limit}) {
        font-size: 16px !important;
        line-height: 24px !important;
      }
    `;
  }}
`;

const CpdsInlinePullQuoteContainerStyleTag = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      position: relative;
      max-width: 644px;
      padding: ${token.spacing.space_24};

      @media only screen and (min-width: ${cpdsMediaQueryVals.cpds_medium_lower_limit}) and (max-width: ${cpdsMediaQueryVals.cpds_medium_upper_limit}) {
        padding: ${token.spacing.space_24} ${token.spacing.space_40};
      }

      @media screen and (max-width: ${cpdsMediaQueryVals.cpds_small_upper_limit}) {
        width: 100%;
        max-height: auto;
        padding: ${token.spacing.space_16};
      }
    `;
  }}
`;

const CpdsInlinePullQuoteStyleTag = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    const { background } = colorMapper(props, token);

    return css`
      display: flex;
      justify-content: center;
      max-width: ${token?.v3_parent_grid_max_width};
      width: 100%;
      background-color: ${background};
      ${(props) => props?.styleOverrides};
    `;
  }}
`;

export {
  CpdsInlinePullQuoteStyleTag,
  CpdsInlinePullQuoteTitleStyleTag,
  CpdsInlinePullQuoteAuthorStyleTag,
  CpdsInlinePullQuoteJobTitleStyleTag,
  CpdsInlinePullQuoteQuotationMark,
  CpdsInlinePullQuoteContainerStyleTag,
};